import { defineComponent as _defineComponent } from 'vue'
import { BillingInfoSubscriptionStatus } from '@/model/Account';
import i18nn from '@/plugins/i18n';
import store from '@/store/store';
import { computed, PropType } from 'vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaywallUpgradeDialog',
  props: {
  // eslint-disable-next-line vue/max-len
  plans: { type: Array as PropType<('pro' | 'business' | 'ultimate')[]>, required: false, default: () => ['business', 'ultimate'] },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;



const router = useRouter();



const upgradePlanAction = () => {
  router.push('/settings/billing?upgrade=true');
};

const isVIP = computed(() => store.state.settings.account.subStatus === BillingInfoSubscriptionStatus.VIP);

const message = computed(() => {
  const plans = props.plans.map((p) => `Guestplan ${p[0].toUpperCase()}${p.slice(1)}`);
  if (plans.length === 0) return '';
  if (plans.length === 1) return plans[0];
  return `${plans.slice(0, -1).join(', ')} ${i18nn.t('label.or')} ${plans[plans.length - 1]}`;
});


return { __sfc: true,props, router, emit, upgradePlanAction, isVIP, message }
}

})